const TAXI_UPDATED = (state, Taxi) => {
  state.Taxi = Taxi
}

const TAXI_VOUCHER_UPDATED = (state, Voucher) => {
  state.Voucher = Voucher
  state.isGetSuccessVoucher = true
}

const TAXI_COMPANIES_UPDATED = (state, taxiCompanies) => {
  state.taxiCompanies = taxiCompanies
}

const LIST_RECEIPT_PAX_UPDATE = (state, listReceiptPax) => {
  state.listReceiptPax = listReceiptPax
}

const TAXI_INFO = (state, data) => {
  state.taxiInfo = data
}

const TAXI_PRICE = (state, data) => {
  state.taxiPrice = data
}

export default {
  TAXI_UPDATED,
  TAXI_VOUCHER_UPDATED,
  TAXI_COMPANIES_UPDATED,
  LIST_RECEIPT_PAX_UPDATE,
  TAXI_INFO,
  TAXI_PRICE
}
